









import { Vue, Component, Prop } from "@/shared/vuepack";

@Component
export default class ErrorSummary extends Vue {
  @Prop()
  formErrors: any[];
}
